<div #parentElement>
  <ng-template module-host></ng-template>  
</div>
